/**
 * Constants for conversation layout and UI spacing
 */

export const CONVERSATION_LAYOUT = {
  /**
   * Responsive bottom padding values for both conversation panel and drawer
   * Used to ensure consistent bottom spacing across different screen sizes
   */
  bottomPadding: {
    mobile: "32px", // xs breakpoint
    tablet: "40px", // sm breakpoint
    desktop: "25px", // md+ breakpoint
  },
} as const;
